module.exports = __webpack_public_path__ + "storeHome/img/mobile-floatIcon-1111.f09208ed.png";